import { useTranslation } from 'react-i18next';
import { trackLanguageToggle } from '../utils/analytics';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'de' : 'en';
    i18n.changeLanguage(newLang);
    trackLanguageToggle(newLang);
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className="header-utility-btn"
      aria-label={`Switch to ${i18n.language === 'en' ? 'German' : 'English'}`}
      aria-pressed={i18n.language === 'de'}
    >
      {i18n.language === 'en' ? 'DE' : 'EN'}
    </button>
  );
} 